import { lazy, Suspense } from 'react';
import { Center, Spinner } from '@chakra-ui/react';
import type { EmojiPickerProps } from './EmojiPicker';

// The picker and its dataset load on first open (M69, D263), so the main
// bundle doesn't carry ~1,900 emoji names in two languages.
const EmojiPicker = lazy(() => import('./EmojiPicker'));

export function LazyEmojiPicker(props: EmojiPickerProps) {
  return (
    <Suspense
      fallback={
        <Center h="100%" minH="120px">
          <Spinner size="sm" color="accent" />
        </Center>
      }
    >
      <EmojiPicker {...props} />
    </Suspense>
  );
}
